/**
 * Mg Marquee — seamless infinite scroll (shared engine)
 *
 * Drives THREE sections via one contract: mg-marquee, mg-icon-bar
 * (marquee layout) and mg-logo-bar (marquee layout). Each renders ONE
 * [data-marquee-list] inside a [data-marquee-track] whose CSS animates the
 * list `translateX(0 → -100%)`. This script measures one list and CLONES it
 * until the track fills `viewport + one list` → with the lists scrolling in
 * lockstep, the row is gapless at ANY width (incl. wide desktop) no matter
 * how few items the merchant added — fixing the trailing-whitespace gap the
 * old clone-once version left when content was narrower than the viewport.
 *
 * Each clone is `inert` + `aria-hidden` so screen readers / Tab never see
 * the duplicated items twice (WCAG 4.1.2), and loses `data-marquee-list`
 * so the original is always re-findable.
 *
 * Re-fills on debounced resize, on `document.fonts.ready` (text marquees
 * reflow once the webfont loads) and on `shopify:section:load` (Theme
 * Editor re-render). Idempotent: re-measures the original each pass and
 * only tops up clones (never removes) — mirrors assets/mg-ba-marquee.js.
 */
(function () {
  if (window.__namyMarqueeInit) return;
  window.__namyMarqueeInit = true;

  /* Width of the nearest clipping ancestor = the visible viewport the row
     scrolls within (the section sets overflow:hidden in all 3 consumers).
     Generic walk so it stays correct regardless of inner-wrapper nesting. */
  function clipWidth(track) {
    var el = track.parentElement;
    while (el && el !== document.body) {
      var ox = getComputedStyle(el).overflowX;
      if (ox === 'hidden' || ox === 'clip' || ox === 'auto' || ox === 'scroll') {
        return el.clientWidth;
      }
      el = el.parentElement;
    }
    return (track.parentElement && track.parentElement.clientWidth) || window.innerWidth || 0;
  }

  function fillTrack(track) {
    /* Original list keeps [data-marquee-list]; clones have it stripped. */
    var list = track.querySelector('[data-marquee-list]');
    if (!list) return;
    var setWidth = list.scrollWidth; /* transforms don't affect scrollWidth */
    if (!setWidth) return;

    var need = clipWidth(track) + setWidth; /* cover viewport + one full set */
    var safety = 0;
    while (track.scrollWidth < need && safety < 60) {
      var clone = list.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.setAttribute('inert', '');
      clone.setAttribute('data-marquee-clone', '');
      clone.removeAttribute('data-marquee-list');
      track.appendChild(clone);
      safety++;
    }
  }

  function fillAll(root) {
    (root || document).querySelectorAll('[data-marquee-track]').forEach(fillTrack);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { fillAll(); });
  } else {
    fillAll();
  }

  /* Webfont reflow can widen text items after first paint → top up clones. */
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () { fillAll(); });
  }

  var fillSoon;
  window.addEventListener('resize', function () {
    (fillSoon || (fillSoon = Mg.debounce(function () { fillAll(); }, 200)))();
  });

  /* Theme Editor re-renders a section after load → re-fill its fresh track. */
  document.addEventListener('shopify:section:load', function (e) {
    fillAll(e.target);
  });
})();
